
















import { defineComponent, ref } from "@vue/composition-api";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import useUserTags from "@/hooks/useUserTags";
import TagsController from "@/components/TagsController";

export default defineComponent({
  name: "UserCategories",
  components: {
    TagsController,
  },
  setup(_, { emit }) {
    const { userTags, userTagsGetData, userTagsUpdateData } = useUserTags();

    const loading = ref(false);

    const onInput = (tags: TagInfo[]) => {
      userTags.value = tags.map(tag => tag.id);
      emit("setValid", !!userTags.value.length);
    };

    const saveFields = () => {
      return userTagsUpdateData(userTags.value);
    };

    const created = async () => {
      emit("setValid", false);
      emit("setCb", saveFields);
      try {
        loading.value = true;
        emit("setLoading", true);
        await userTagsGetData();
      } finally {
        loading.value = false;
        emit("setLoading", false);
      }
    };

    created();

    return {
      loading,
      userTags,
      onInput,
      TagInfoType,
    };
  },
});
